import { useState } from "react";

import cars from "../data/cars";
import CarCard from "../components/CarCard";
import SearchFilter from "../components/SearchFilter";

function Cars() {

  const [filtered, setFiltered] =
    useState(cars);

  return (
    <section className="cars">

      <h1>
        Explore Cars
      </h1>

      <SearchFilter
        cars={cars}
        setFiltered={setFiltered}
      />

      <div className="grid">

        {filtered.map((car) => (
          <CarCard
            key={car.id}
            car={car}
          />
        ))}

      </div>

    </section>
  );
}

export default Cars;